import { Drawer } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Title } from '@/shared/uikit/Title';
import { Tabs } from '@/shared/uikitV2/antd/Tabs';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0 !important;
  }
`;

export const Container = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const Header = styled.div`
  border-bottom: 1px solid ${COLORS.systemDark100};
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  &.hasTabs {
    padding-bottom: 0;
  }
`;

export const StyledTitle = styled(Title)`
  font-weight: 700;
  font-size: 22px;
  line-height: 24px;
`;

export const Body = styled.div`
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${COLORS.systemDark100};
  padding: 16px 24px;
  gap: 16px;
`;

export const TabsStyled = styled(Tabs)`
  &&& .ant-tabs {
    height: 32px;
    overflow: hidden;
  }

  &&& .ant-tabs-nav {
    margin-bottom: 0;

    &::before {
      content: none;
    }
  }

  &&& .ant-tabs-ink-bar {
    height: 0.5px;
    background: ${COLORS.systemSky200};
  }

  &&& .ant-tabs-nav-list {
    display: flex;
    width: 100%;
    height: 100%;
  }

  &&& .ant-tabs-tab {
    flex: 1 1 0;
    margin: 0;
    padding: 4px 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
